import { render, staticRenderFns } from "./PrintPosFaCiade.vue?vue&type=template&id=1f4015b8"
import script from "./PrintPosFaCiade.vue?vue&type=script&lang=js"
export * from "./PrintPosFaCiade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports